import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getNiceTimeOnly, isValidDeviceObject } from '@iotv/datamodel-core';
import { LinkType } from '@iotv/lns';
import { Alert, AlertTitle, Button, Stack, ThemeProvider } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { v4 } from 'uuid';
import { AppMainViewContext } from '../../../../ContextProviders/AppContextProvider';
import { denseDataGridTheme } from '../../../../cosmetics/Themes/DenseDataGrid';
import { DeviceControlDAO } from '../../../../data/DeviceControlDAO';
import { Severity } from '../../../../types';
import { DialogWrapper } from '../../../common/DiaglogWrapper';
import { DecodedPayloadPopUp, StripedDataGrid } from '../../../factories/DataGrid';
import { DeviceConfigContext } from '../../Context/deviceConfigContext';
import { dlQueueColumns } from './colDef';
const debug = process.env.REACT_APP_DEBUG && false;
export const DownlinkQueueView = () => {
    const [{ UserFunctions }] = useContext(AppMainViewContext);
    const { state: deviceContextState, dispatch } = useContext(DeviceConfigContext);
    const { device, downlinkQueue } = deviceContextState;
    const [refreshTimestamp, setRefreshTimestamp] = useState();
    const lastRefreshMessage = refreshTimestamp ? `Refreshed at ${getNiceTimeOnly(refreshTimestamp)}` : 'Refreshing now...';
    const noDownlinksQueuedMessage = `No downlinks queued for ${device?.name ?? device?.eui ?? ''}`;
    const getDownlinkQueue = async () => {
        if (isValidDeviceObject(device)) {
            const { err, data } = await DeviceControlDAO.device.downlink_queue.list({ DeviceEui: device.eui });
            if (err) {
                UserFunctions.setUserMessage({ content: err.message, id: v4(), label: '', type: 'MessageBar', severity: Severity.error });
            }
            else if (data) {
                if (data.downlinkQueue.length === 0) {
                    UserFunctions.setUserMessage({ content: noDownlinksQueuedMessage, id: v4(), label: '', type: 'SnackBar', severity: Severity.info });
                }
                dispatch({ downlinkQueue: data.downlinkQueue });
                setRefreshTimestamp(Date.now());
            }
        }
    };
    useEffect(() => {
        if (device)
            getDownlinkQueue();
    }, [device?.sk]);
    const [wRef, setWRef] = useState(null);
    const getPayloadDialog = (children, header) => (_jsx(DialogWrapper, { header,
        open: true,
        setClosed: () => setWRef(null),
        children,
        fullWidth: true,
        maxWidth: 'xl' }));
    const handleCellClick = (e) => {
        const matchedKey = 'payload';
        if (isValidDeviceObject(device)) {
            if (e.field === matchedKey) {
                const payloadStr = e.value;
                if (typeof payloadStr === 'string') {
                    const linkType = LinkType.DOWN;
                    const port = null;
                    setWRef(getPayloadDialog(_jsx(DecodedPayloadPopUp, { payloadStr, linkType, device, port }), 'Decoded payload'));
                }
            }
            debug && console.log(e);
        }
    };
    const dataGridProps = {
        onCellClick: handleCellClick,
        density: 'compact',
        columns: dlQueueColumns,
        rows: downlinkQueue ?? [],
        getRowClassName: (params) => (params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'),
        rowHeight: 32,
        columnHeaderHeight: 32,
        rowSelection: false,
        disableColumnMenu: true,
        disableColumnSelector: true,
        disableColumnResize: true,
        disableVirtualization: true,
        initialState: { sorting: { sortModel: [{ field: 'timestamp', sort: 'desc' }] } },
    };
    return (_jsxs(Stack, { marginBlockStart: 1, gap: 1, children: [_jsxs(Alert, { severity: "info", action: _jsx(Button, { color: "inherit", size: "small", onClick: getDownlinkQueue, children: "Refresh" }), children: [(downlinkQueue ?? []).length === 0 && _jsx(AlertTitle, { children: noDownlinksQueuedMessage }), lastRefreshMessage] }), isValidDeviceObject(device) && 0 < (downlinkQueue ?? []).length && (_jsx(ThemeProvider, { theme: denseDataGridTheme, children: _jsx(StripedDataGrid, { ...dataGridProps }) })), wRef] }));
};
